import React, { createContext, useContext } from "react";
import * as APIConstants from "../Constants/APIConstants";
import axios from "axios";

const CurrentContext = createContext();

function AdContext({ children }) {
  async function GetAds({ typeId = null, amount = 1 }) {
    let jsonRequest = [
      {
        typeId: typeId,
        amount: amount,
        pos: "na",
      },
    ];
    let response = await axios
      .get(APIConstants.AD_BASE_URL, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          jsonRequest: JSON.stringify(jsonRequest),
        },
      })
      .catch((error) => {
        return error;
      });

    return response;
  }

  // Fetch a replacement ad from Scout for a given placement ("banner" | "box").
  // Returns { ad, capped }. `ad` is the served ad object ({ image_url,
  // destination_url, impression_url, click_url, ... }) or null when Scout holds
  // out / has no fill / errors, so the caller can fall back to the legacy ad.
  // `capped` is true when Scout's draw landed on a vendor at its daily
  // impression cap: the caller must backfill the slot rather than fall back,
  // since the legacy ad would serve that same capped vendor.
  async function GetScoutAd({ placement, vendorId = null }) {
    if (!placement) {
      return { ad: null, capped: false };
    }
    const source =
      typeof window !== "undefined"
        ? window.location.hostname
        : "funker530.com";
    // Legacy vendor the Ad Function assigned the slot to, so Scout can
    // attribute the serve back to it.
    const params = { placement, source };
    if (vendorId != null) {
      params.vendor_id = vendorId;
    }
    try {
      const response = await axios.get(APIConstants.SCOUT_SERVE_URL, {
        params,
      });
      return {
        ad: response?.data?.ad ?? null,
        capped: response?.data?.capped === true,
      };
    } catch (error) {
      return { ad: null, capped: false };
    }
  }

  return (
    <CurrentContext.Provider value={{ GetAds, GetScoutAd }}>
      {children}
    </CurrentContext.Provider>
  );
}

export function UseAdContext() {
  const context = useContext(CurrentContext);
  if (!context) {
    throw new Error("useAdContext must be used within a Context");
  }
  return context;
}

export default AdContext;
